<template>
  <main role="main" class="home">
    <exhibitPill v-if="getHomeExhibit.isVisible" :centerText="getHomeExhibit.status" :exhibitName="getHomeExhibit.title" :exhibitUrl="getHomeExhibit.url"></exhibitPill>
    <div v-if="getHomeExhibit.isVisible" class="heroContainer">
      <img v-if="getHomeExhibit.imghero.type === 'image'" :src="getHomeExhibit.imghero.url" alt="">
      <video v-if="getHomeExhibit.imghero.type === 'video'"  playsinline autoplay muted loop>
        <source :src="getHomeExhibit.imghero.url" :type="getHomeExhibit.imghero.mime">
      </video>
    </div>
  </main>
</template>

<script>

import ExhibitPill from '../components/ExhibitPill'
import EventBus from './../util/EventBus'
import * as types from './../store/mutation-types'

export default {
  name: 'home',
  components: {
    ExhibitPill,
    EventBus
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: document.title,
    // all titles will be injected into this template
    titleTemplate: document.title
  },
  computed: {
    getHomeExhibit () {
      let isVisible = false
      let status = ''
      let url = ''
      let title = ''
      let imghero = ''
      let homeExhibitUid = this.$store.getters.getPageByUID('exhibitions').homepageexhibition

      if (homeExhibitUid) {
        let homeExhibit = this.$store.getters.getPageByID('exhibitions/' + homeExhibitUid)

        var offset = 2
        let today = new Date(new Date().getTime() + offset * 3600 * 1000)

        // let exhibitStart = new Date(new Date(homeExhibit.begining).getTime() + offset * 3600 * 1000)
        let exhibitStart = new Date(new Date(homeExhibit.vernissage).getTime() + offset * 3600 * 1000)

        let exhibitEnd = new Date(new Date(homeExhibit.end).getTime() + offset * 3600 * 1000)
        exhibitEnd.setHours(23, 59, 59)

        url = homeExhibit.id
        title = homeExhibit.title
        imghero = homeExhibit.imghero

        homeExhibit.files.forEach((file) => {
          if (file.url.includes(imghero)) {
            imghero = file
          }
        })

        console.log(today)
        console.log(exhibitEnd)
        if (today > exhibitStart && today < exhibitEnd) {
          isVisible = true
          status = 'Current'
          // EventBus.$emit('app.physicsActivate')
          this.$store.commit(types.UPDATE_PHYSICS, { field: 'physicsB', value: true })
        }
        if (today < exhibitStart && today < exhibitEnd) {
          isVisible = true
          status = 'Upcoming'
          // EventBus.$emit('app.physicsActivate')
          this.$store.commit(types.UPDATE_PHYSICS, { field: 'physicsB', value: true })
        }
        if (today > exhibitStart && today > exhibitEnd) {
          isVisible = false
          status = 'last'
          // EventBus.$emit('app.physicsDelete')
          this.$store.commit(types.UPDATE_PHYSICS, { field: 'physicsB', value: false })
          // console.log('desactivate home')
        }
      }

      return { isVisible, status, title, url, imghero }
    }
  },
  mounted () {
    EventBus.$emit('app.physicsDelete')
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">

.home {
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .heroContainer {
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	touch-action: manipulation;
    // pointer-events: none;
    width: 100vmin;
    height: 100vmin;
    object-fit: contain;
    // margin: auto;
    overflow: hidden;
  }
  img, video {
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	touch-action: manipulation;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
  }
}

</style>
